/* Skeleton — a loading placeholder shaped like the content it replaces.
 *
 * Shaped deliberately: a spinner tells someone to wait, a skeleton tells them
 * what is coming and stops the layout jumping when it lands.
 */
import { cn } from '@/lib/utils'

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('cn-skeleton', className)} aria-hidden />
}

/** A post-shaped skeleton, used while the first feed page loads. */
export function PostSkeleton() {
  return (
    <div className="cn-card p-s4">
      <div className="flex items-center gap-s3">
        <Skeleton className="h-10 w-10 rounded-pill" />
        <div className="flex-1 space-y-s2">
          <Skeleton className="h-3 w-32" />
          <Skeleton className="h-2.5 w-20" />
        </div>
      </div>
      <div className="mt-s4 space-y-s2">
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-4/5" />
      </div>
    </div>
  )
}
